import React, { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router'

// Create the context
const FormContext = createContext()

// Custom hook to use the form context
export const useFormContext = () => useContext(FormContext)

export const FormProvider = ({ children }) => {
  const [formType, setFormType] = useState('faleConosco')
  const location = useLocation()

  useEffect(() => {
    // Get the current path
    const path = location.pathname

    // Determine form type based on URL path
    if (
      path.startsWith('/projects') ||
      path === '/development' ||
      path === '/business-agility' ||
      path === '/pmo' ||
      path === '/ato' ||
      path === '/gestao-de-portfolio' ||
      path === '/gestao-de-mudancas' ||
      path === '/desenvolvimento-de-softwares' ||
      path === '/desenvolvimento-de-solucoes' ||
      path === '/recuperacao-de-projetos' ||
      path === '/programa-new-techs' ||
      path === '/squad' ||
      path === '/escopo-fechado' ||
      path === '/smartsourcing'
    ) {
      setFormType('projects')
    } else if (
      path.startsWith('/innovation') ||
      path === '/intelligence' ||
      path === '/ia' ||
      path === '/data' ||
      path === '/finep' ||
      path === '/cloud' ||
      path === '/devops' ||
      path === '/finops' ||
      path === '/migracao' ||
      path === '/seguranca' ||
      path === '/monitoramento'
    ) {
      setFormType('innovation')
    } else if (
      path.startsWith('/solutions') ||
      path === '/erp' ||
      path === '/erp-expertise' ||
      path === '/advisor' ||
      path === '/ams' ||
      path === '/erp-smartsourcing' ||
      path === '/omnifactory'
    ) {
      setFormType('solutions')
    } else {
      setFormType('faleConosco')
    }
  }, [location.pathname])

  return (
    <FormContext.Provider value={{ formType }}>{children}</FormContext.Provider>
  )
}
